<div class="spinner">
  <span class="bounce1" />
  <span class="bounce2" />
  <span class="bounce3" />
</div>

<style>
  .spinner {
    width: 80px;
    height: 25px;
    /* text-align: center; */
    display: flex;
    justify-content: space-between;
  }

  .spinner > span {
    width: 30%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);

    border-radius: 9999px;
    display: inline-block;
    animation: BounceAnimation 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes BounceAnimation {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
</style>
